<div class="row mb-5">
  <div class="col-lg-12">
    <div class="card shadow-sm hover-shadow transition-fast rounded-lg mb-5">
      <div class="card-body p-5 px-0 px-lg-4 py-lg-4">
        <div class="container text-start">
          <div class="row mb-3">
            <div class="col-12">
              <h4 class="font-weight-bold text-center text-lg-start">الأسئلة المتكررة</h4>
            </div>
          </div>



          <div class="accordion " id="QA">
            <!-- <div class="accordion-item">
              <h2 class="accordion-header" id="questionHeading-0">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#question-collapse-0" aria-expanded="false" aria-controls="question-collapse-0">
                  Accordion Item #1
                </button>
              </h2>
              <div id="question-collapse-0" class="accordion-collapse collapse" aria-labelledby="questionHeading-0"
                data-bs-parent="#QA">
                <div class="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the
                  <code>.accordion-flush</code> class. This is the first item's accordion body.</div>
              </div>
            </div> -->

            <div class="accordion-item" *ngFor="let faq of faqs; let i = index">
              <h2 class="accordion-header" [id]="'questionHeading-' + i">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#question-collapse-' + i" aria-expanded="false"
                  [attr.aria-controls]="'question-collapse-' + i">
                  {{ faq.question }}
                </button>
              </h2>
              <div [id]="'question-collapse-' + i" class="accordion-collapse collapse"
                [attr.aria-labelledby]="'questionHeading-' + i" data-bs-parent="#QA">
                <div class="accordion-body">
                  <ng-container *ngFor="let block of faq.answer">
                    <ng-container [ngSwitch]="block.type">
                      <div *ngSwitchCase="'text'" class="mb-2">{{ block.content }}</div>
                      <ul *ngSwitchCase="'list'" class="mb-2">
                        <li *ngFor="let item of block.items">{{ item }}</li>
                      </ul>
                      <div *ngSwitchCase="'link'" class="mb-2">
                        <a [href]="block.href" target="_blank">{{ block.label }}</a>
                      </div>
                      <div *ngSwitchCase="'image'" class="mb-2 text-center">
                        <img [src]="('cdnBase' | env) + block.src" class="img-fluid img-thumbnail" *ngIf="block.src">
                        <div *ngIf="block.caption">{{ block.caption }}</div>
                      </div>
                      <div *ngSwitchCase="'phone'" class="mb-2">
                        <a [href]="'tel:' + block.number">{{ block.label || block.number }}</a>
                      </div>
                      <div *ngSwitchCase="'email'" class="mb-2">
                        <a [href]="'mailto:' + block.address">{{ block.label || block.address }}</a>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>